import { createContext } from 'react';
export var SidebarContext = createContext({
    setContentIsScrolling: function () {
        /* no op */
    },
});
SidebarContext.displayName = 'SidebarContext';
